<template>
  <div class="userLayout">
    <nav class="mobile-user-nav" aria-label="用户中心导航">
      <router-link v-for="link in userLinks" :key="link.path" :to="link.path">{{ link.label }}</router-link>
    </nav>
    <div class="navLeft">
      <el-row class="tac">
        <el-col >
          <el-menu :default-active="$route.path" class="el-menu-vertical-demo" router unique-opened>
            <el-menu-item index="/dataCenter">
              <i class="el-icon-menu"></i>
              <span slot="title">数据中心</span>
            </el-menu-item>

            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-s-custom"></i>
                <span>我的</span>
              </template>
              <el-menu-item index="/myApi">我的API</el-menu-item>
              <el-menu-item index="/applyApi">申请API</el-menu-item>
              <el-menu-item index="/myOrder">我的订单</el-menu-item>
              <el-menu-item index="/myBookMatch">我的匹配任务</el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span>账号管理</span>
              </template>
              <el-menu-item index="/updatePwd">修改密码</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <div class="navRight">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userLinks: [
        { path: '/dataCenter', label: '概览' },
        { path: '/myApi', label: '我的API' },
        { path: '/myOrder', label: '订单' },
        { path: '/myBookMatch', label: '匹配任务' },
        { path: '/applyApi', label: '申请API' },
        { path: '/updatePwd', label: '修改密码' }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.userLayout {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 80px);
  max-width: 1200px;
  margin: 0 auto;
  .navLeft {
    width: 190px;
    flex-shrink: 0;
    //height: 100%;
    border-right: solid 1px #e6e6e6;
    border-collapse: collapse;
    .el-menu {
    border-right: none;
}
  }
  .navRight {
    width: auto;
    flex: 1;
    min-width: 0;
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .userLayout {
    display: block;
    background: #f5f7fa;

    .navLeft {
      width: 100%;
      border-right: none;
      border-bottom: solid 1px #e6e6e6;
      background: #fff;

      .el-row, .el-col {
        width: 100%;
      }

      .el-menu {
        display: block;
        border-bottom: none;
      }

      .el-menu-item, .el-submenu > .el-submenu__title {
        text-align: left;
        padding-left: 20px;
        border-bottom: 1px solid #f0f0f0;
        height: 48px;
        line-height: 48px;
      }

      .el-submenu .el-menu {
        background: #fafafa;
        display: none;
      }

      .el-submenu.is-active .el-menu {
        display: block;
      }

      .el-submenu .el-menu-item {
        text-align: left;
        padding-left: 50px;
        font-size: 13px;
        height: 44px;
        line-height: 44px;
      }
    }

    .navRight {
      width: 100%;
      padding: 0;
    }
  }
}
</style>
<style lang="less" scoped>
.mobile-user-nav { display: none; }
@media screen and (max-width: 768px) {
  .userLayout .navLeft { display: none; }
  .mobile-user-nav { display: flex; overflow-x: auto; gap: 4px; padding: 10px 12px; background: #f5f8fc; border-bottom: 1px solid #e5eaf0; }
  .mobile-user-nav a { flex-shrink: 0; padding: 8px 10px; border-radius: 6px; font-size: 13px; color: #526176; }
  .mobile-user-nav .router-link-active { background: #e4efff; color: #2676d9; font-weight: 600; }
}
</style>
